( function($) {
	var locations = [];
	var roles = [];
	var hours = [];
	var allLocations = '';


	// Show the filters if the Filter Search button has been tapped
	$( ".filter-button-container a.filter-button" ).on( "click", function() {
		$( ".filter-section-container" ).toggleClass( "show" );
		$( ".jlfamily-jobs-page-container" ).toggleClass( "no-scroll" );
	} );

	// Close button for filter section
	$( ".section-title a.close-filters-btn" ).on( "click", function() {
		$( ".filter-section-container" ).toggleClass( "show" );
		$( ".jlfamily-jobs-page-container" ).toggleClass( "no-scroll" );
	} );


	// Use label to set the checkboxes
	$( "label.job-location-selection, label.job-location-select-all" ).on( "click", function () {
		var checkbox = $( this ).find( 'input' );
        
		if( checkbox.prop( 'checked' ) ) {
			checkbox.prop( "checked", false );
		}
		
		else {
			checkbox.prop( "checked", true );
		}
	} );


	// Toggle badge colours
	$( ".filter-badge" ).on( "click", function() {
		var targetHour = $( this ).attr( 'hour' );
		var targetRole = $( this ).attr( 'role' );
		
		$( this ).toggleClass( 'selected-badge' );

		if( targetHour ) {
			$( '.main-results-container' ).find( 'a[hour="' + targetHour + '"]' ).toggleClass( 'uk-hidden' );
		}

		if( targetRole ) {
			$( '.main-results-container' ).find( 'a[role="' + targetRole + '"]' ).toggleClass( 'uk-hidden' );
		}
	} );


	$( ".result-filter-badge" ).on( "click", function() {
		var targetHour = $( this ).attr( 'hour' );
		var targetRole = $( this ).attr( 'role' );		

		if( targetHour ) {
			$( '.category-filter' ).find( 'a[hour="' + targetHour + '"]' ).toggleClass( 'selected-badge' );

			console.log( 'targetHour' );
		}

		if( targetRole ) {
			$( '.category-filter' ).find( 'a[role="' + targetRole + '"]' ).toggleClass( 'selected-badge' );

			console.log( 'targetRole' );
		}
	} );



  function load_more_func( e, el, item ) {
    e.preventDefault();

		// Selected item doesn't exist in the location array, let's add it!
		if( !locations.includes( el.attr( 'location' ) ) ) {
			locations.push( el.attr( 'location' ) );
		}

		// Selected item appears in the location array, let's remove it!
		else if( locations.includes( el.attr( 'location' ) ) ) {
			locations = locations.filter( item => item !== el.attr( 'location' ) );
		}


		// Selected item doesn't exist in the role array, let's add it!
		if( !roles.includes( el.attr( 'role' ) ) ) {
			roles.push( el.attr( 'role' ) );
		}

		// Selected item appears in the role array, let's remove it!
		else if( roles.includes( el.attr( 'role' ) ) ) {
			roles = roles.filter( item => item !== el.attr( 'role' ) );
		}


		// Selected item doesn't exist in the hour array, let's add it!
		if( !hours.includes( el.attr( 'hour' ) ) ) {
			hours.push( el.attr( 'hour' ) );
		}

		// Selected item appears in the hour array, let's remove it!
		else if( hours.includes( el.attr( 'hour' ) ) ) {
			hours = hours.filter( item => item !== el.attr( 'hour' ) );
		}


		// When user is selecting all locations
		if( el.attr( 'allLocations' ) ) {			
			// Remove the 'JSON' bits and make it a string
			allLocations = el.attr( 'allLocations' ).replace( /[\[\]"]+/g, '' );
			
			// Make this string into an array
			allLocations = allLocations.split( ',' );

			// If the select all is checked, add all provincial locations
			if( el.find( 'input' ).prop( "checked" ) ) {
				locations = allLocations;
			}

			// Else, show all global locations
			else {
				locations = [];
			}
		}


		// Append search list on mobile 
		if( locations.length > 0 && locations[0] !== undefined ) {
			// Modify list to look like city names
			locationList = locations.toString().replace( /,/g, ', ' );
			locationList = locationList.replace( /-/g, " " );
			
			// Remove all existing items
			$( '.location-results-container' ).children().remove();

			// Add the new list
			$( '.location-results-container' ).append( 
				'<span>Showing Results for <span class="uk-text-capitalize">' + locationList + '</span></span>' 
			);
		}

		else {
			$( '.location-results-container' ).children().remove();
		}

	

    // Pass in any necessary attributes
    var	data = {
			action: el.attr( "action" ),
			'post_type': 'job',
			'location': locations,
			'role': roles,
			'hour': hours,
			site: "", // value required for multisites
		};

    $.ajax( {
      url: data.site + "/wp-admin/admin-ajax.php", // AJAX handler
      data: data,
      type: "POST",

      beforeSend: function () {
				console.log( 'add opacity and loading spinner over the current list' );
      },

      success: function( html ) {
        if( html ) {
					// Remove all existing items
					item.children().remove();

					// Add the new query list
          item.append( html );
        }
				
				else {
					console.log( 'something went wrong' );
        }
      },
    } );
  }

	$( '.job-location-selection, .job-badge-selection' ).on( 'click', function(e) {		
		load_more_func( e, $( this ), $( ".results-section-container" ) );
	} );

	$( '.job-location-select-all' ).on( 'click', function(e) {		
		// If the action is checking an unchecked box
		if( $( this ).find( 'input' ).prop( "checked" ) ) {
			// Uncheck all 'select all' from the provinces
			$( this ).closest( '.location-list' ).find( '.job-location-select-all input' ).prop( 
				'checked', false
			);

			// And all the cities
			$( this ).closest( '.location-list' ).find( '.job-location-selection input' ).prop( 
				'checked', false
			);

			// Add a check to the selected checkbox
			$( this ).find( 'input' ).prop( 'checked', true );
		}

		// Check/Uncheck all cities within the province
		$( this ).closest( '.sub-locations' ).find( ".job-location-selection input" ).prop( 
			'checked', $( this ).find( 'input' ).prop( 'checked' ) 
		);
		
		load_more_func( e, $( this ), $( ".results-section-container" ) );
	} );
} )( jQuery );
